import React, { useState, useEffect } from "react";
import { styled } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
// import DialogKurir from "./DialogKurir";
import { Checkbox, Divider, Grid, Typography } from "@material-ui/core";
import { useData } from "../../../../components/firebase/DataProvider";
import {
  FieldValue,
  firefunctions,
  storage,
} from "../../../../components/firebase/FirebaseProvider";
import { findOnePromoOngkir } from "../../../../utils/promo";
import { duration } from "../../../../utils/duration";
import currency from "../../../../utils/currency";
import DialogKurir from "./DialogKurir";
import { useHistory } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";

function Pengiriman({
  alamatId,
  subcart: {
    berat_total,
    total_tagihan,
    biaya_pengiriman,
    biaya_pengiriman_before,
    length,
    width,
    height,
    pengiriman,
    resi_otomatis_mp,
    resi_otomatis_mp_kurir,
    resi_otomatis_mp_resi,
    resi_otomatis_mp_file,
    pakai_asuransi,
    nilai_infaq,
    inpoin,
    promo_voucher,
    nilai_voucher,
    kategori_voucher,
    total_tagihan_harga_normal,
  },
  loadDebounce,
  setLoadDelivery,
  loadDelivery,
  findOneVoucher,
  tipe_order,
}) {
  const history = useHistory();
  const { alamat, cartRef, promoOngkir, cart, global_resi_mp, preorderUtils } =
    useData();
  const [ongkir, setOngkir] = useState({});
  // const [shouldRecalculate, setShouldRecalculate] = useState(false);
  const [isInsuranceOn, setIsInsuranceOn] = useState(
    pakai_asuransi ? true : false
  );
  const [form, setForm] = useState({
    kurir: resi_otomatis_mp_kurir || "",
    resi: resi_otomatis_mp_resi || "",
    file: resi_otomatis_mp_file || "",
  });
  const [openKurir, setOpenKurir] = useState({
    open: false,
  });
  const [error, setError] = useState({
    upload: "",
  });

  const handleChange = async (e) => {
    let value = e.target.value;
    setForm({
      ...form,
      [e.target.name]: value,
    });

    // setError({
    //   ...error,
    //   [e.target.name]: "",
    // });

    try {
      const data = {
        subcarts: {
          [alamatId]: {
            resi_otomatis_mp_kurir: value,
          },
        },
        updated_at: FieldValue.serverTimestamp(),
      };
      await cartRef.set(data, { merge: true });
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    // if (shouldRecalculate && pengiriman) {
    async function updatePengiriman() {
      try {
        // console.log("lewat");
        const findOngkir = ongkir?.[pengiriman?.type]?.find?.(
          (item) => item.rate_id === pengiriman.rate_id
        );
        setLoadDelivery(true);
        if (findOngkir) {
          // console.log("lewat1", findOngkir);
          const findPromoOngkir = findOnePromoOngkir(promoOngkir);
          let promoOn = false;
          if (findPromoOngkir?.scope === "provider") {
            if (findPromoOngkir?.providers?.includes(findOngkir?.provider)) {
              promoOn = true;
            } else {
              promoOn = false;
            }
          } else if (findPromoOngkir?.scope === "tipe_product") {
            if (findPromoOngkir?.tipe_product?.includes(tipe_order)) {
              promoOn = true;
            } else {
              promoOn = false;
            }
          } else {
            promoOn = true;
          }
          const nilaiPersenPromoOngkir =
            (findPromoOngkir?.nilai / 100) * findOngkir?.finalRate;
          const totalNilaiPromoOngkir =
            findPromoOngkir?.tipe === "%"
              ? nilaiPersenPromoOngkir > findPromoOngkir?.max_promo_ongkir
                ? findPromoOngkir?.max_promo_ongkir
                : nilaiPersenPromoOngkir
              : findPromoOngkir?.max_promo_ongkir > findOngkir?.finalRate
              ? findOngkir?.finalRate
              : findPromoOngkir?.max_promo_ongkir;
          const tagihan = total_tagihan;
          const max_promo_tokorame =
            tagihan >= findPromoOngkir?.min_transaksi && promoOn ? true : false;
          const max_promo_ongkir =
            tagihan >= findPromoOngkir?.min_transaksi && promoOn
              ? totalNilaiPromoOngkir
              : findOngkir?.discount && max_promo_tokorame
              ? findOngkir?.discount
              : 0;

          const calculatepromoongkir =
            max_promo_ongkir +
            (kategori_voucher === "ongkir" ? nilai_voucher : 0) -
            (findOngkir?.finalRate -
              (findOngkir?.discount && max_promo_tokorame
                ? findOngkir?.discount
                : 0));
          const biaya_pengiriman =
            calculatepromoongkir < 0
              ? Math.round(Math.abs(calculatepromoongkir)) -
                (inpoin?.category === "ongkir" ? inpoin?.coin : 0)
              : inpoin?.category === "ongkir"
              ? inpoin?.coin
              : 0;
          const infaq = nilai_infaq ?? 0;
          let total_pembayaran = isInsuranceOn
            ? total_tagihan +
              biaya_pengiriman +
              findOngkir?.insuranceRate +
              infaq
            : total_tagihan + biaya_pengiriman + infaq;
          let pakai_asuransi = isInsuranceOn;
          let asuransi_pengiriman = isInsuranceOn
            ? findOngkir?.insuranceRate
            : 0;
          if (findOngkir?.compulsory_insurance === 1) {
            setIsInsuranceOn(true);
            pakai_asuransi = true;
            asuransi_pengiriman = findOngkir?.insuranceRate;
            total_pembayaran = Math.round(
              total_tagihan +
                biaya_pengiriman +
                findOngkir?.insuranceRate +
                infaq
            );
          }

          const TypeOrder = Object.values(
            Object.values(cart?.subcarts ?? {}).filter(
              (item) => item?.checked === "Y"
            )?.[0]?.products ?? {}
          )?.[0]?.type;

          const isPreorder =
            TypeOrder === "preorder" && preorderUtils?.down_payment_option
              ? {
                  nilai_dp: Math.round(
                    (preorderUtils?.down_payment_percentage / 100) *
                      total_pembayaran
                  ),
                }
              : "";

          const data = {
            subcarts: {
              [alamatId]: {
                pengiriman: {
                  ...findOngkir,
                  kurir: findOngkir?.name,
                  tipe: findOngkir?.rate_name,
                },
                pakai_asuransi,
                asuransi_pengiriman,
                nilai_promo_ongkir: max_promo_ongkir,
                biaya_pengiriman_before:
                  findOngkir?.finalRate -
                  (findOngkir?.discount && max_promo_tokorame
                    ? findOngkir?.discount
                    : 0),
                biaya_pengiriman,
                promo_ongkir:
                  tagihan >= findPromoOngkir?.min_transaksi && promoOn
                    ? findPromoOngkir?.id
                    : "",
                total_pembayaran,
                ...isPreorder,
                resi_otomatis_mp: FieldValue.delete(),
                resi_otomatis_mp_kurir: FieldValue.delete(),
                resi_otomatis_mp_resi: FieldValue.delete(),
              },
            },
            is_payment_code: "midtrans",
            is_payment_name: "midtrans",
            tipe_order: TypeOrder,
            unique_code: FieldValue.delete(),
            updated_at: FieldValue.serverTimestamp(),
          };
          await cartRef.set(data, { merge: true });
        }
        if (resi_otomatis_mp) {
          // console.log("lewat2");
          const infaq = nilai_infaq ?? 0;
          let total_pembayaran = Math.round(total_tagihan + infaq);

          const TypeOrder =
            Object.values(
              Object.values(cart?.subcarts ?? {}).filter(
                (item) => item?.checked === "Y"
              )?.[0]?.products ?? {}
            )?.[0]?.type ?? "normal";

          const data = {
            subcarts: {
              [alamatId]: {
                total_pembayaran,
              },
            },
            is_payment_code: "midtrans",
            is_payment_name: "midtrans",
            tipe_order: TypeOrder,
            unique_code: FieldValue.delete(),
            updated_at: FieldValue.serverTimestamp(),
          };
          await cartRef.set(data, { merge: true });
        }
        setLoadDelivery(false);
      } catch (error) {
        console.log("error effect = ", error);
      }
    }
    updatePengiriman();

    //   setShouldRecalculate(false);
    // }
  }, [
    promoOngkir,
    inpoin?.coin,
    total_tagihan,
    isInsuranceOn,
    ongkir,
    pengiriman?.type,
    pengiriman?.tipe,
    nilai_infaq,
    nilai_voucher,
    // nilai_voucher,
    // shouldRecalculate,
    // cartRef,
    // alamatId,
  ]);

  // useEffect(() => {
  //   setShouldRecalculate(true);
  // }, [nilai_infaq, inpoin?.coin, promoOngkir]);

  useEffect(() => {
    let maxRequest = 0;
    const findAlamat = alamat.find((al) => al.id === alamatId);
    if (findAlamat && !resi_otomatis_mp) {
      async function cekOngkir() {
        setLoadDelivery(true);
        try {
          // console.log("lol");
          const getOngkir = firefunctions.httpsCallable("getOngkir");

          const destination = findAlamat?.kelurahan?.id;
          const destinationCoord = findAlamat?.koordinat
            ? `${findAlamat.koordinat?.latitude},${findAlamat.koordinat?.longitude}`
            : null;
          const weight = berat_total / 1000;
          const price = total_tagihan;
          let ongkirparams = {
            d: destination,
            l: length,
            w: width,
            h: height,
            wt: weight,
            v: Math.round(price),
            cod: 0,
            type: 2,
          };

          if (destinationCoord) {
            ongkirparams.destinationCoord = destinationCoord;
          }

          const response = await getOngkir(ongkirparams);

          setOngkir(response?.data);

          const kurirAwal = Object?.entries(response?.data ?? {})
            ?.filter(([key, value]) => value?.length > 0)
            ?.map(([key, value]) => key)?.[0];

          const item = response.data?.[kurirAwal]?.sort(
            (a, b) => a?.finalRate - b?.finalRate
          )?.[0];

          // console.log(response?.data);

          const data = {
            subcarts: {
              [alamatId]: {
                pengiriman: {
                  ...item,
                  kurir: item?.name,
                  tipe: item?.rate_name,
                  type: kurirAwal,
                },
              },
            },
            updated_at: FieldValue.serverTimestamp(),
          };
          await cartRef.set(data, { merge: true });
          // setShouldRecalculate(true);
        } catch (e) {
          console.log("cek ongkir error", e.message);
          if ((e.message = "Request failed with status code 502")) {
            maxRequest = maxRequest + 1;
            // console.log(maxRequest);
            return maxRequest === 3 ? history.goBack() : cekOngkir();
          }
        }
        setLoadDelivery(false);
      }
      if (width && Object.values(ongkir).length <= 0) {
        cekOngkir();
      }
    }
  }, [alamatId, berat_total, total_tagihan]);

  const handleChoseKurir = async (kurir) => {
    if (pengiriman?.rate_id === kurir?.rate_id) {
      setOpenKurir({ open: false });
      return;
    }
    setLoadDelivery(true);
    try {
      const findPromoOngkir = findOnePromoOngkir(promoOngkir);
      let promoOn = false;
      if (findPromoOngkir?.scope === "provider") {
        if (findPromoOngkir?.providers?.includes(kurir?.provider)) {
          promoOn = true;
        } else {
          promoOn = false;
        }
      } else {
        promoOn = true;
      }

      const tagihan = total_tagihan;
      const nilaiPersenPromoOngkir =
        (findPromoOngkir?.nilai / 100) * kurir?.finalRate;
      const totalNilaiPromoOngkir =
        findPromoOngkir?.tipe === "%"
          ? nilaiPersenPromoOngkir > findPromoOngkir?.max_promo_ongkir
            ? findPromoOngkir?.max_promo_ongkir
            : nilaiPersenPromoOngkir
          : findPromoOngkir?.max_promo_ongkir > kurir?.finalRate
          ? kurir?.finalRate
          : findPromoOngkir?.max_promo_ongkir;
      const max_promo_tokorame =
        tagihan >= findPromoOngkir?.min_transaksi && promoOn ? true : false;
      const max_promo_ongkir =
        tagihan >= findPromoOngkir?.min_transaksi && promoOn
          ? totalNilaiPromoOngkir
          : kurir?.discount
          ? kurir?.discount
          : 0;
      let nilaiVoucherOngkirTora = 0;
      let fieldNilaiVoucher = {};
      if (promo_voucher && kategori_voucher === "ongkir") {
        const findVoucher = await findOneVoucher(
          promo_voucher,
          total_tagihan,
          kurir?.finalRate,
          max_promo_ongkir
        );
        nilaiVoucherOngkirTora = Math.round(findVoucher);
        fieldNilaiVoucher = {
          nilai_voucher: nilaiVoucherOngkirTora,
        };
      }

      const calculatepromoongkir =
        max_promo_ongkir +
        nilaiVoucherOngkirTora -
        (kurir?.finalRate -
          (kurir?.discount && max_promo_tokorame ? kurir?.discount : 0));
      const biaya_pengiriman =
        calculatepromoongkir < 0
          ? Math.round(Math.abs(calculatepromoongkir))
          : 0;
      const infaq = nilai_infaq ?? 0;
      const data = {
        subcarts: {
          [alamatId]: {
            pengiriman: {
              ...kurir,
              kurir: kurir?.name,
              tipe: kurir?.rate_name,
            },
            biaya_pengiriman_before:
              kurir?.finalRate -
              (kurir?.discount && max_promo_tokorame ? kurir?.discount : 0),
            biaya_pengiriman: biaya_pengiriman,
            nilai_promo_ongkir: max_promo_ongkir,
            promo_ongkir:
              tagihan >= findPromoOngkir?.min_transaksi && promoOn
                ? findPromoOngkir?.id
                : "",
            total_pembayaran: total_tagihan + biaya_pengiriman + infaq,
            inpoin: FieldValue.delete(),
            resi_otomatis_mp: FieldValue.delete(),
            resi_otomatis_mp_kurir: FieldValue.delete(),
            resi_otomatis_mp_resi: FieldValue.delete(),
            resi_otomatis_mp_file: FieldValue.delete(),
            ...fieldNilaiVoucher,
          },
        },
        updated_at: FieldValue.serverTimestamp(),
      };

      // console.log("ini dari function", data);
      await cartRef.set(data, { merge: true });
      setOpenKurir({ open: false });
    } catch (e) {
      console.log(e.message);
    }
    setLoadDelivery(false);
  };

  const handleSaveResi = async () => {
    const data = {
      subcarts: {
        [alamatId]: {
          resi_otomatis_mp_resi: form.resi,
        },
      },
      updated_at: FieldValue.serverTimestamp(),
    };

    await cartRef.set(data, { merge: true });
  };

  const toggleAsuransi = (e) => {
    if (pengiriman?.compulsory_insurance === 1) {
      setIsInsuranceOn(true);
    } else {
      setIsInsuranceOn(e.target.checked);
      // setShouldRecalculate(true);
    }
  };
  const kurirData = global_resi_mp?.list;

  const handleUploadFile = async (e) => {
    const file = e.target.files[0];
    if (
      !["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
        file.type
      )
    ) {
      setError((error) => ({
        ...error,
        upload: `Tipe file tidak didukung: ${file.type}`,
      }));
    } else if (file.size > 2000000) {
      setError((error) => ({
        ...error,
        upload: `Ukuran file terlalu besar > 2MB`,
      }));
    } else {
      const reader = new FileReader();

      reader.onabort = () => {
        setError((error) => ({
          ...error,
          upload: `Proses pembacaan file dibatalkan`,
        }));
      };

      reader.onerror = () => {
        setError((error) => ({
          ...error,
          upload: "File tidak bisa dibaca",
        }));
      };

      reader.onload = async () => {
        setError((error) => ({
          ...error,
          upload: "",
        }));
        try {
          setLoadDelivery(true);
          const now = Date.now();
          const storageRef = storage.ref();
          const urlExt = file.name.substring(file.name.lastIndexOf("."));
          const urlRef = await storageRef.child(
            `resi_mp/${cart.id}/${now}_${cart.kode_order}.${urlExt}`
          );

          const urlSnapshot = await urlRef.putString(reader.result, "data_url");

          const urlUrl = await urlSnapshot.ref.getDownloadURL();
          setForm({ ...form, file: file.name });
          const data = {
            subcarts: {
              [alamatId]: {
                resi_otomatis_mp_file: urlUrl,
              },
            },
            updated_at: FieldValue.serverTimestamp(),
          };
          await cartRef.set(data, { merge: true });
          setLoadDelivery(false);
        } catch (e) {
          console.log(e.message);
          setError((error) => ({
            ...error,
            upload: e.message,
          }));
          setLoadDelivery(false);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const Input = styled("input")({
    display: "none",
  });

  return (
    <div>
      <div
        style={
          resi_otomatis_mp
            ? {
                marginLeft: "20px",
                marginBottom: "10px",
                marginRight: "20px",
                border: "1px solid #0ABE9E",
                borderRadius: 6,
              }
            : {
                marginLeft: "20px",
                marginRight: "20px",
                marginBottom: "10px",
                border: "1px solid #0ABE9E",
                borderRadius: 6,
                backgroundColor: "#F3FFFD",
              }
        }
      >
        <div style={{ margin: 10 }}>
          <div>
            <Typography
              style={{
                marginBottom: "3px",
                marginTop: "3px",
                fontSize: 12.5,
                color: "#0ABE9E",
              }}
            >
              {resi_otomatis_mp
                ? "Resi Otomatis Marketplace"
                : "Opsi Pengiriman"}
            </Typography>
          </div>
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
          {resi_otomatis_mp ? (
            <Grid
              container
              spacing={1}
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              <Grid item xs={12}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Pilih Kurir
                  </InputLabel>
                  <Select
                    id="kurir"
                    name="kurir"
                    label="Pilih Kurir"
                    value={form.kurir}
                    onChange={handleChange}
                    disabled={loadDelivery}
                  >
                    {tipe_order === "preorder" ? (
                      <MenuItem value={"PICKUP"}>PICKUP</MenuItem>
                    ) : (
                      kurirData.map((option) => {
                        return <MenuItem value={option}>{option}</MenuItem>;
                      })
                    )}
                    {tipe_order === "preorder" ? (
                      ""
                    ) : (
                      <MenuItem value="lainnya">Lainnya</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              {form.kurir === "lainnya" && (
                <Grid item xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    id="lainya"
                    name="lainya"
                    label="Kurir Lainnya"
                    variant="outlined"
                    disabled={loadDelivery}
                    value={form.lainya || ""}
                    // error={error.lainya ? true : false}
                    // helperText={error.lainya}
                    onChange={handleChange}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  id="resi"
                  name="resi"
                  label="No. Resi"
                  variant="outlined"
                  disabled={loadDelivery}
                  value={form.resi || ""}
                  // error={error.resi ? true : false}
                  // helperText={error.resi}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      resi: e.target.value.replace(/'|"/g, ""),
                    })
                  }
                  onBlur={handleSaveResi}
                />
              </Grid>
              {tipe_order === "preorder" ? (
                ""
              ) : (
                <Grid item xs={12}>
                  <label htmlFor="contained-button-file">
                    <Input
                      accept="image/jpeg,image/png,image/jpg"
                      id="contained-button-file"
                      multiple
                      type="file"
                      onChange={handleUploadFile}
                    />
                    <Button
                      variant="outlined"
                      style={{ textTransform: "none", color: "grey" }}
                      disabled={loadDelivery}
                      component="span"
                      fullWidth
                      size="small"
                    >
                      {form.file
                        ? form.file.slice(0, 39) + "..."
                        : "Upload Foto"}
                    </Button>
                    {error?.upload ? (
                      <Typography
                        color="error"
                        align="center"
                        style={{
                          // marginBottom: "3px",
                          marginTop: "3px",
                          fontSize: 11.5,
                          // color: "grey",
                        }}
                      >
                        {error?.upload}
                      </Typography>
                    ) : null}
                  </label>
                </Grid>
              )}
            </Grid>
          ) : (
            <div
              onClick={() =>
                loadDelivery ? null : setOpenKurir({ open: true })
              }
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <div>
                {loadDelivery ? (
                  <>
                    <Skeleton
                      variant="text"
                      style={{
                        width: 80,
                      }}
                    />
                    <Skeleton
                      variant="text"
                      style={{
                        width: 120,
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Typography
                      style={{
                        marginBottom: "3px",
                        marginTop: "3px",
                        fontSize: 12,
                      }}
                    >
                      {pengiriman?.name} - {pengiriman?.rate_name}
                    </Typography>
                    <Typography
                      style={{
                        marginBottom: "3px",
                        marginTop: "3px",
                        fontSize: 11.5,
                        color: "grey",
                      }}
                    >
                      Estimasi tiba{" "}
                      {duration(pengiriman?.min_day, pengiriman?.max_day)} hari
                    </Typography>
                  </>
                )}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {loadDelivery ? (
                  <Skeleton
                    variant="text"
                    style={{
                      width: 80,
                    }}
                  />
                ) : (
                  <>
                    <div>
                      {biaya_pengiriman_before !== biaya_pengiriman && (
                        <Typography
                          style={{
                            // marginBottom: "3px",
                            // marginTop: "3px",
                            textDecoration: "line-through",
                            color: "grey",
                            fontSize: 11.2,
                          }}
                        >
                          {currency(biaya_pengiriman_before)}
                        </Typography>
                      )}
                      <Typography
                        style={{
                          // marginBottom: "3px",
                          // marginTop: "3px",
                          fontSize: 12,
                        }}
                      >
                        {currency(biaya_pengiriman)}
                      </Typography>
                    </div>
                    {/* <div style={{ alignSelf: "center", marginRight: "10px" }}> */}
                    <NavigateNextIcon
                      style={{ marginRight: "10px" }}
                      fontSize="small"
                    />
                  </>
                )}
                {/* </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
      {resi_otomatis_mp ? null : (
        <>
          <Divider />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "20px",
              marginRight: "20px",
            }}
          >
            <Typography
              style={{ marginBottom: "3px", marginTop: "3px", fontSize: 12 }}
            >
              Asuransi Pengiriman
            </Typography>
            <Checkbox
              style={{ marginRight: "-10px" }}
              checked={isInsuranceOn}
              disabled={pengiriman?.compulsory_insurance === 1 || loadDelivery}
              onChange={toggleAsuransi}
              name="checkedB"
              color="primary"
              size="small"
            />
          </div>
        </>
      )}
      <Divider />
      <DialogKurir
        openKurir={openKurir.open}
        closeKurir={() => setOpenKurir({ open: false })}
        changeKurir={handleChoseKurir}
        data={Object.entries(ongkir)
          .map(([key, value]) => {
            return {
              title: key,
              data: value,
            };
          })
          .filter((item) => item.data.length > 0)}
        oldId={pengiriman?.rate_id}
      />
    </div>
  );
}

export default Pengiriman;
